import brand from '@helpers/brand';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import animation from '@helpers/animation';
import { Device, from, until } from '@helpers/media';
import RichTextStyles from '@stories/Widgets/RichText/RichText.styles';
const Container = styled.footer `
  color: ${brand.white};
  background-color: ${brand.sage.sageDark};
`;
const Wrapper = styled(SectionWrapper) ``;
const Inner = styled.div `
  padding: 40px 0 120px;

  @media ${from(Device.DesktopSmall)} {
    padding: 70px 0 15px;
  }
`;
const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    grid-template-rows: 1fr auto auto;
  }
`;
const TextLinkStyles = css `
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: ${brand.white};
    transition: transform 0.3s, background-color 0.3s;
    transition-timing-function: ${animation.secondary};
    transform: scaleX(0);
  }
`;
const LogoHolder = styled.a `
  margin-bottom: 35px;
  grid-column: 1 / span 12;

  &:focus {
    outline: ${brand.white} solid 1px;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 4;
  }

  @media ${from(Device.DesktopSmall)} {
    margin-bottom: 70px;
    grid-column: 1 / span 3;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 2;
  }
`;
const Logo = styled.img `
  width: 106px;

  @media ${from(Device.Tablet)} {
    width: 180px;
  }

  @media ${from(Device.DesktopSmall)} {
    width: 230px;
  }

  @media ${from(Device.Desktop)} {
    width: 250px;
  }
`;
const SocialIconHolder = styled.div `
  margin-bottom: 30px;
  display: flex;
`;
const SocialLink = styled.a `
  margin-right: 15px;
  transition: opacity ${animation.secondary} 0.3s;

  &:hover,
  &:focus {
    opacity: 0.7;
  }
`;
const SocialIcon = styled.img `
  height: 20px;
`;
const ContactHolder = styled.div `
  grid-column: 1 / span 12;
  grid-gap: 0px 25px;

  @media ${until(Device.Tablet)} {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    margin-bottom: 40px;
  }

  @media ${from(Device.Tablet)} {
    grid-row: 2;
    grid-column: 1 / span 4;
  }

  @media ${from(Device.DesktopSmall)} {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-row: 2;
    grid-column: 1 / span 5;
    margin-bottom: 55px;
  }

  @media ${from(Device.Desktop)} {
    grid-row: 2;
    grid-column: 1 / span 4;
  }
`;
const ContactCol = styled.div `
  color: ${brand.white};

  @media ${from(Device.DesktopSmall)} {
    grid-row: 2;
  }
`;
const ContactLink = styled.div ``;
const ContactAddress = styled.div `
  ${RichTextStyles.contentStyles};

  p {
    margin-bottom: 5px;

    @media ${from(Device.Tablet)} {
      font-size: 16px;
      line-height: 22px;
    }

    @media ${from(Device.DesktopSmall)} {
      font-size: 18px;
      line-height: 26px;
    }
  }
`;
const TelNum = styled.a `
  color: ${brand.white};
  font-size: 18px;
  line-height: 26px;
  display: inline-block;
  margin-bottom: 15px;
  text-decoration: none;

  ${TextLinkStyles};

  @media ${until(Device.DesktopSmall)} {
    font-size: 16px;
    line-height: 22px;
  }

  &:focus,
  &:hover {
    outline: none;
    &:after {
      transform: scaleX(1);
    }
  }
`;
const Email = styled.a `
  color: ${brand.white};
  font-size: 18px;
  line-height: 26px;
  display: inline-block;
  margin-bottom: 15px;
  text-decoration: none;

  ${TextLinkStyles};

  @media ${until(Device.DesktopSmall)} {
    font-size: 16px;
    line-height: 22px;
  }

  &:focus,
  &:hover {
    outline: none;
    &:after {
      transform: scaleX(1);
    }
  }
`;
const NavHolder = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 5 / span 8;
    display: flex;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 4 / span 9;
    display: block;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 10;
  }
`;
const Nav = styled.div `
  margin-bottom: 20px;

  @media ${until(Device.DesktopSmall)} {
    flex: 0 1 auto;
  }
`;
const NavContainer = styled.ul `
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media ${until(Device.Tablet)} {
    justify-content: flex-start;
  }
`;
const NavLinkItem = styled.li `
  margin-left: 40px;
  margin-bottom: 15px;

  @media ${until(Device.DesktopSmall)} {
    flex: 1 0 50%;
    margin-left: 0;
  }

  @media ${from(Device.DesktopSmall)} {
    margin-left: 30px;
  }

  @media ${from(Device.Desktop)} {
    margin-left: 40px;
  }

  &:first-child {
    margin-left: 0;
  }
`;
const NavItem = styled.a `
  ${ParagraphStyles.LargeStyles};
  color: ${brand.white};
  text-decoration: none;
  display: inline-block;
  margin-bottom: 0;

  ${TextLinkStyles};

  @media ${until(Device.DesktopSmall)} {
    margin-right: 15px;
    font-size: 16px;
    line-height: 20px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 18px;
    line-height: 24px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 28px;
  }

  &:focus,
  &:hover {
    outline: none;
    &:after {
      transform: scaleX(1);
    }
  }
`;
const CtaHolder = styled.div `
  a + a {
    margin-left: 20px;

    @media ${until(Device.DesktopSmall)} {
      margin-left: 0;
    }
  }

  @media ${until(Device.DesktopSmall)} {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    align-items: flex-start;

    a {
      margin-bottom: 15px;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    text-align: right;
  }
`;
const BaseNav = styled.div `
  flex: 1 0 auto;
  grid-column: 1 / span 12;
  margin-top: 20px;

  @media ${from(Device.Tablet)} {
    margin-top: 0;
    grid-row: 2;
    grid-column: 5 / span 7;
    display: flex;
    align-items: flex-end;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-row: 3;
    grid-column: 1 / span 10;
  }
`;
const BaseNavContainer = styled.ul `
  display: flex;
  flex-wrap: wrap;

  @media ${until(Device.Tablet)} {
    flex-direction: column;
  }
`;
const BaseNavLinkItem = styled.li `
  margin-bottom: 18px;
  margin-right: 30px;

  @media ${from(Device.Desktop)} {
    margin-right: 50px;
    margin-bottom: 15px;
  }

  &:last-child {
    margin-right: 0;
  }
`;
const BaseNavItem = styled.a `
  ${ParagraphStyles.RegularStyles};
  color: ${brand.white};
  text-decoration: none;
  display: inline-block;
  margin-bottom: 0;

  ${TextLinkStyles};

  @media ${until(Device.Desktop)} {
    margin-left: 0;
    font-size: 14px;
    line-height: 17px;
  }

  &:focus,
  &:hover {
    outline: none;
    &:after {
      transform: scaleX(1);
    }
  }
`;
const Copyright = styled.div `
  grid-column: 1 / span 12;

  @media ${until(Device.Tablet)} {
    margin-top: 15px;
  }

  @media ${from(Device.Tablet)} {
    grid-row: 3;
    grid-column: 1 / span 12;
    margin-top: 25px;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 11 / span 2;
    text-align: right;
    margin-top: 0;
  }
`;
const CopyrightContent = styled.p `
  @media ${until(Device.Desktop)} {
    font-size: 14px;
    line-height: 17px;
  }
`;
const SiteFooterStyles = {
    BaseNav,
    BaseNavContainer,
    BaseNavItem,
    BaseNavLinkItem,
    ContactAddress,
    ContactCol,
    ContactHolder,
    ContactLink,
    Container,
    Copyright,
    CopyrightContent,
    CtaHolder,
    Email,
    Grid,
    Inner,
    Logo,
    LogoHolder,
    Nav,
    NavContainer,
    NavHolder,
    NavItem,
    NavLinkItem,
    SocialIcon,
    SocialLink,
    SocialIconHolder,
    TelNum,
    Wrapper,
};
export default SiteFooterStyles;
